var _defs, _g, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{opacity:0.6;}.cls-2{fill:#FFFFFF;}.cls-3{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;stroke-width:0.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.71,9.16a.89.89,0,0,0-.49.15l5.2,4.93a.53.53,0,0,0,.75,0l5.19-4.93a.91.91,0,0,0-.49-.15Zm-.87.63a.92.92,0,0,0-.06.33v6.4a1,1,0,0,0,.15.52l3.68-3.67Zm11.9,0L18,13.37,21.65,17a1,1,0,0,0,.15-.52v-6.4a1.2,1.2,0,0,0-.06-.33Zm-4.21,4-.94.89a1.16,1.16,0,0,1-1.59,0l-.94-.89-3.64,3.63a.88.88,0,0,0,.29.05H20.87a.93.93,0,0,0,.29-.05Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4.97,
    y1: 11.24,
    x2: 2.29,
    y2: 11.24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.66,
    y1: 14.82,
    x2: 4.53,
    y2: 14.82
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.66,
    y1: 11.24,
    x2: 6.32,
    y2: 11.24
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSend);
export default __webpack_public_path__ + "static/media/email_send.986836de7f57fe66ce7a1fa43e2df728.svg";
export { ForwardRef as ReactComponent };